import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import LanguageType from '../../../entity/Language';

interface Props {
  language: LanguageType;
  className?: string;
}

const Language = ({ language }: ClassAttributes<HTMLElement> & Props) => (
  <FormattedMessage id={`language.${language}`} />
);

export default Language;
